import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AllOtherPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [allOtherPricing, setAllOtherPricing] = useState([]);
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [topics, setTopics] = useState([]);
  const [topicsId, setTopicsId] = useState("");

  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  const getAllTopics = () => {
    axios
      .get(`${API_BASE_URL}/topics?categoryId=${categoryId}`)
      .then((response) => {
        // console.log(response);
        setTopics(response.data?.topics);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllTopics();
  }, [categoryId]);

  const fetchData = () => {
    axios
      .get(`${API_BASE_URL}/pricing/exam-notes?topicId=${topicsId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result?.data?.data);
        const data = result?.data?.data;
        setAllOtherPricing(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleAddOtherPricing = () => {
    navigate("/exam-notes-pricing/add-other-pricing");
  };
  const handleViewAllOtherPricing = () => {
    navigate("/exam-notes-pricing/all-other-pricing");
  };
  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };

  const handleEdit = (id) => {
    navigate(`/exam-notes-pricing/edit-other-pricing/${id}`);
  };
  const handleDelete = (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this note price?"
    );
    if (confirmed) {
      axios
        .delete(`${API_BASE_URL}/admin/pricing/exam-notes/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => {
          console.log(result);
          alert("Other price Deleted Successfully.");
          fetchData();
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting other price.");
        });
    }
  };
  return (
    <div id="allschoolnotes-inner-wrapper">
      <BiArrowBack
        onClick={handleGoBack}
        className="left-arrow-icon mt-3"
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          fontSize: "25px",
          color: "#000", // Customize the color as needed
        }}
      />

      <div className="allschoolnotes-header-div">
        <h5>All Other Notes Pricing</h5>
        <div className="allschoolnotes-header-btns">
          <button className="add-note-btn" onClick={handleAddOtherPricing}>
            + Add Other Pricing
          </button>
          <button className="all-notes-btn" onClick={handleViewAllOtherPricing}>
            All Pricing
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="note-detail-form form-container">
        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Category</label>
          <select
            className="new-chapter-dropdown"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            required
          >
            <option value="">-Select Category-</option>
            {category &&
              category.map((item, idx) => (
                <option key={idx} value={item?._id}>
                  {item?.category}
                </option>
              ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Category Topic</label>
          <select
            className="new-chapter-dropdown"
            value={topicsId}
            onChange={(e) => setTopicsId(e.target.value)}
            required
          >
            <option value="">-Select Topic-</option>
            {topics &&
              topics.map((item, idx) => (
                <option key={idx} value={item._id}>
                  {item?.topic}
                </option>
              ))}
          </select>
        </div>

        <div className="form1-btns">
          <button className="btn-save">Search Pricing</button>
        </div>
      </form>

      <div className="allschoolnotes-table-container">
        <h5>All Nios Notes Pricing</h5>
        <table className="allschoolnotes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Category</th>
              <th>Topic</th>
              <th>Notes Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allOtherPricing.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item?.topicId?.categoryId?.category}</td>
                <td>{item?.topicId?.topic}</td>
                <td>{item?.price}</td>

                <td className="table-action-icons">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(item._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(item._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllOtherPricing;
